<template>
    <div>
      <v-snackbar
      v-if="session && !isConference(session.remoteIdentity.uri.user)"
      v-model="session"
      timeout="-1"
      multi-line
      content-class="pt-0 pr-0 pl-2"
      :right="!max"
      >
        <!-- <button @click='refreshMedia()'>REFRESH MEDIA</button> -->
        <!-- <h1>Status: <span v-if='session.videoEnable'>VIDEO ENABLED</span><span v-else>NO DISPLAY VIDEO</span></h1> -->
        <v-row class='ma-0 pa-0' no-gutters v-if="session.state === 'Established'">
          <v-col class='ma-0 pa-0 text-right' v-if='max==false'>
            <v-btn x-small icon @click='max=!max; snackWidth=300'>
              <v-icon color="orange">mdi-window-maximize</v-icon>
            </v-btn>
          </v-col>
          <v-col class='ma-0 pa-0 text-right' v-if='max==true'>
            <v-btn x-small icon @click='max=!max; snackWidth=62'>
              <v-icon color="orange">mdi-window-minimize</v-icon>
            </v-btn>
            <max-session></max-session>
          </v-col>
        </v-row>
        <v-row no-gutters class='ml-2'>
          <v-col class='ma-0 pr-2 py-0' v-if='session.remoteIdentity.displayName'>
            <h6 v-if="max && session.state === 'Established' && session.remoteIdentity.displayName"><nobr>{{session.remoteIdentity.displayName}}</nobr></h6>
          </v-col>
          <v-col class='ma-0 pr-2 py-0'>
            <h6 v-if="max && session.state === 'Established'"><nobr>{{formatNum(session.remoteIdentity.uri.user)}}</nobr></h6>
          </v-col>
          <v-col class='ma-0 pa-0'>
            <h6 v-if="max && session.state === 'Established' && hold" class="PULSE"><nobr>(On Hold)</nobr></h6>
          </v-col>
          <v-spacer></v-spacer>
          
        </v-row>
        <v-divider class='mt-0'></v-divider>
        <v-row no-gutters class='mt-n2 mb-1'>
          <v-col>
            <div>
              <div ref='localMedia' v-if='session.localVideo' :style='(session.videoEnable) ? "position:absolute; right:0; margin-right:3px; margin-top:4px; border:2px orange solid;" : "border:2px orange solid;"'></div>
              <div ref='media' v-if='session.videoEnable' :class='{ zerosize: !session.videoEnable }'></div>
            </div>
          </v-col>
          <!--<v-col>
            <div ref='localMedia' v-if='max == true && session.localVideo'></div>
          </v-col>-->
        </v-row>
        <v-card color="rgb(0,0,0,0)" elevation="0" :width='snackWidth'>
          <v-card-actions v-if='session.state === "Established" && showNumPad == true'><numpad></numpad></v-card-actions>
          <v-card-actions class='ma-0 pa-0'>
            <v-btn 
              v-if='isIncoming(session) && session.state === "Initial"' 
              @click='$sip.answer()' 
              color="green"
              dark
              fab
              >
              <v-icon>
                mdi-phone
              </v-icon>
            </v-btn>
            <v-btn 
              @click='$sip.bye()' 
              dark
              color="red" 
              fab
              class='ml-1'>
                <v-icon>mdi-phone-hangup-outline</v-icon>
            </v-btn>
            <div v-if='!max' class='pl-3'>
              <v-btn 
                v-if="session.state == 'Established' && (!session.isMuted && !myChannel.id) || (!myChannel.muted && myChannel.id)" 
                @click='myChannel.id ? muteCaller(myChannel) : $sip.mute(true)' 
                color="teal" 
                dark
                fab>
                  <v-icon>mdi-microphone</v-icon>
              </v-btn>
              <v-btn 
                v-if="session.state == 'Established' && (session.isMuted && !myChannel.id) || (myChannel.muted && myChannel.id)" 
                @click='myChannel.id ? unmuteCaller(myChannel) : $sip.mute(false)' 
                color="teal" 
                dark
                fab>
                  <v-icon>mdi-microphone-off</v-icon>
              </v-btn>
            </div>
            <v-divider vertical class='pl-3 pr-0' v-if="session.state !== 'Established'"> </v-divider>
            <v-spacer></v-spacer>
            <v-container v-if="session.state !== 'Established'">
              <v-row>
                <h4 class='px-3' v-if="session.state !== 'Established' && session.remoteIdentity.displayName">{{session.remoteIdentity.displayName}}</h4>
              </v-row>
              <v-row>
                <h4 class='px-3' v-if="session.state !== 'Established'">{{formatNum(session.remoteIdentity.uri.user)}}</h4>
              </v-row>
            </v-container>
            <v-spacer> </v-spacer>
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <div>
                          <v-btn 
                            v-if="device.recording == 'terminated'" 
                            @click="$sip.dtmf('*');$sip.dtmf('3')"
                                                       
                            fab
                            small
                            v-bind="attrs"
                            v-on="on">
                              <v-icon>mdi-record</v-icon>
                          </v-btn>
                          <v-btn 
                            v-if="device.recording == 'confirmed'"
                            @click="$sip.dtmf('*');$sip.dtmf('4')"
                            color="red" 
                            dark
                            fab
                            small
                            v-bind="attrs"
                            v-on="on">
                              <v-icon>mdi-record</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <span v-if="device.recording=='terminated'">Record</span>
                      <span v-if="device.recording=='confirmed'">Stop recording</span>
                    </v-tooltip>
                  
            <media-input-selector v-if='max'></media-input-selector>
            <v-card
            v-if="max"
            color="rgb(0,0,0,0)" elevation='0'
            >
              <v-container ma-0 py-0 pr-2 v-if="session.state == 'Established'">
                <v-row class="mb-1" no-gutters>
                  <v-col class='mr-1'>
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <div>
                          <v-btn 
                            v-if="session.state == 'Established' && !session.localVideo" 
                            @click='addStream()'
                            color="blue" 
                            dark
                            fab
                            small
                            v-bind="attrs"
                            v-on="on">
                              <v-icon>mdi-video</v-icon>
                          </v-btn>
                          <v-btn 
                            v-if="session.state == 'Established' && session.localVideo" 
                            @click='addStream()'
                            color="blue" 
                            dark
                            fab
                            small
                            v-bind="attrs"
                            v-on="on">
                              <v-icon>mdi-video-off</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <span v-if="!session.localVideo">Camera On</span>
                      <span v-if="session.localVideo">Camera Off</span>
                    </v-tooltip>
                  </v-col>
                  <v-col class='mr-1'>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div>
                          <v-btn 
                            v-if="session.state == 'Established' && (!session.isMuted && !myChannel.id) || (!myChannel.muted && myChannel.id)" 
                            @click='myChannel.id !== null ? muteCaller(myChannel) : $sip.mute(true)' 
                            color="teal" 
                            dark
                            fab
                            small
                            v-bind="attrs"
                            v-on="on">
                              <v-icon>mdi-microphone</v-icon>
                          </v-btn>
                          <v-btn 
                            v-if="session.state == 'Established' && (session.isMuted && !myChannel.id) || (myChannel.muted && myChannel.id)" 
                            @click='myChannel.id !== null ? unmuteCaller(myChannel) : $sip.mute(false)' 
                            color="teal" 
                            dark
                            fab
                            small
                            v-bind="attrs"
                            v-on="on">
                              <v-icon>mdi-microphone-off</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <span v-if="!session.isMuted">Mute</span>
                      <span v-if="session.isMuted">Un-Mute</span>
                    </v-tooltip>
                  </v-col>
                  <v-col>
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                          v-if="'Established' === session.state" 
                          @click="showNumPad = !showNumPad"
                          color="blue"
                          fab
                          small
                          v-bind="attrs"
                          v-on="on">
                          <v-icon>mdi-dialpad</v-icon>
                        </v-btn>
                      </template>
                      <span>Dialpad</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col class='mr-1'>
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <div>
                          <v-btn 
                            v-if="session.state == 'Established'" 
                            @click='addDisplay()'
                            color="teal" 
                            dark
                            fab
                            small
                            v-bind="attrs"
                            v-on="on">
                              <v-icon>mdi-monitor-share</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <span>Share Screen</span>
                    </v-tooltip>
                  </v-col>
                  <v-col class='mr-1'>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div>
                          <v-btn 
                            v-if="session.state == 'Established' && !session.isHeld" 
                            @click='$sip.hold(true); hold=true' 
                            color="blue" 
                            dark
                            fab
                            small
                            v-bind="attrs"
                            v-on="on">
                              <v-icon>mdi-phone-paused</v-icon>
                          </v-btn>
                          <v-btn 
                            v-if="session.state == 'Established' && session.isHeld" 
                            @click='$sip.hold(false); hold=false' 
                            color="blue" 
                            fab
                            small
                            v-bind="attrs"
                            v-on="on">
                              <v-icon>mdi-phone-in-talk</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <span v-if="!session.isHeld">Hold</span>
                      <span v-if="session.isHeld">Un-Hold</span>
                    </v-tooltip>
                  </v-col>
                  <v-col>
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <div 
                            v-bind="attrs"
                            v-on="on">
                          <transfer-menu></transfer-menu>
                        </div>
                      </template>
                      <span>Transfer Call</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-card-actions>
        </v-card>
      </v-snackbar>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { Invitation } from 'sip.js';
import MediaInputSelector from '../components/media-input-selector.vue';
import TransferMenu from '../components/TransferMenu.vue'
import NumPad from '../components/numpad.vue'
import MaxSession from '../components/MaxSession.vue';
import ConferenceCommon from '../mixins/conferencecommon';
import Common from '../mixins/common';

export default {
  data: () =>({
    hold: false,
    max: true,
    snackbar: false,
    menu: false,
    transferNum: null,
    showNumPad: false,
    snackWidth: 300,
    maxSession: false,
  }),
  mounted() { 
    this.attachMedia() 
    this._keyListener = function(e) {
      if (e.target.className === 'v-input__slot') return;
      if (e.target.className === 'v-text-field__slot') return;
      if (e.target.className === 'v-text-field__details') return;
      if (e.target.className === 'v-text-field__append-inner') return;
      if (e.target.className === 'v-text-field__append-outer') return;
      if (e.target.className === 'v-text-field__prepend-inner') return;
      if (e.target.className === 'v-text-field__prepend-outer') return;
      if (e.target.className === 'v-text-field__slot') return;
      if (e.target.className == 'ql-editor ql-blank') return;
      if (e.target.className == 'ql-editor' || e.target.className == 'ql-editor ql-blank') return;
      

      switch (e.target.tagName) {  
        case "INPUT": case "SELECT": case "TEXTAREA": return;  
      }  
      if (e.key === "m") {
          console.log('m key pressed');
          e.preventDefault();
          if (this.myChannel.id !== null) {
            this.myChannel.muted ? this.unmuteCaller(this.myChannel) : this.muteCaller(this.myChannel);
          }
          else {
            this.session.isMuted ? this.$sip.mute(false) : this.$sip.mute(true);
          }
          console.log('toggled mute');
      }
    };
    document.addEventListener('keydown', this._keyListener.bind(this));
  },
  updated() { this.attachMedia() },
  beforeDestroy() {
    document.removeEventListener('keydown', this._keyListener);
  },
  computed: {
    ...mapState(["lineKeys"]),
    session: {
      get() { return this.$store.getters['sip/session'] },
    },
    showMedia: {
      get() { 
        if (!this.session) return false;
        if (this.session.mediaElement) return this.max == true && this.session.mediaElement.srcObject.getVideoTracks().length != 0
        else return false;  
      }
    },
    numberCalling: {
      // This will show the number on the dialpad, but will not always match to the session
      // TODO: get this from the session instead.
      //
      // (will matter more when there are multiple sessions)
      get: function() { return this.$store.state.number; },
      set: function(v) { this.$store.commit('number',v)}
    },
    media: {
      get: function() {
        if (this.session) {
          return this.session.mediaElement;
        }
        return null;
      }
    },
    localVideo: {
      get: function() {
        if (this.session) {
          return this.session.localVideo;
        }
        return null;
      }
    },
    isDev: {
      get() { return process.env.NODE_ENV!=='production' }
    },
    myChannel: {
      get: function() { 
        return this.$store.getters['conference/myChannel']; 
      },
    },
  },
  components: {
    'media-input-selector': MediaInputSelector,
    'transfer-menu': TransferMenu,
    'numpad': NumPad,
    'max-session': MaxSession,
  },
  mixins: [ConferenceCommon, Common],
  methods: {
    addStream() { this.$sip.vid(); },
    addDisplay() { this.$sip.display(); },

    refreshMedia() { this.$sip.refreshMedia(); },
    
    debug(e) {
      console.log('debug: ', e)
    },

    logLineKeys(lk) {
      console.log(this.lineKeys)
      console.log('lineKeyId: ', lk.line_label)
    },
    isIncoming: it => it instanceof Invitation,
    attachMedia() {
      if (!this.session) return;
      if (this.$refs.media) {
        this.$refs.media.innerHTML = '';
        if (!!this.session.mediaElement) {
          this.session.mediaElement.width=this.snackWidth;
          if (this.session.mediaElement) this.$refs.media.appendChild(this.session.mediaElement);
        }
      }
      if (this.$refs.localMedia) {
        this.$refs.localMedia.innerHTML = '';
        if (!!this.session.localVideo) {
          console.log('local video is ', this.session.localVideo);
          this.session.localVideo.style.display='block';
          this.session.localVideo.style.cssText += "transform: scale(-1, 1);";
          if (this.session.videoEnable) this.session.localVideo.width=this.snackWidth/4;
          else this.session.localVideo.width=this.snackWidth;
          if (this.session.localVideo) this.$refs.localMedia.appendChild(this.session.localVideo); 
        }
      }
    },
    numberFromURI(uri) {
      return uri.toString().substring(4, 10);
    },
    isConference(num) {
      try {
        return num.includes('CONF');
      }
      catch (e) {
        return false;
      }
    },
    formatNum(num) {
      if (!num) return null;
      if (num.includes('CONF')){
        return 'Conference'
      }
      num = String(num);
      if (num.length == 10){
        num="(" + num.substring(0,3) + ") " + num.substring(3,6) + "-" + num.substring(6, 10);
      }
      return num;
    }
  },
  watch: {
    session() {
      try {
	if(this.session && window.sforce) {
                        console.log('open cti ' + window.sforce);
                        console.log('open cti ' + window.sforce.opencti);
                        console.log( window.sforce.opencti);
			window.sforce.opencti.isSoftphonePanelVisible({callback: (response) => {
				console.dir(response);
				if (response.success) {
          			  console.log('API method call executed successfully! returnValue:', response.returnValue);
				  if(!response.returnValue.visible) {

                        		window.sforce.opencti.setSoftphonePanelVisibility({visible: true, callback: (response) => {
		                                console.log('-------------------------- opencall_back -----------');
                		                console.dir(response);
		                        } });
					
				  }
			         } else { 
			            console.error('Something went wrong! Errors:', response.errors);
         			}	
			}});
        }
      } catch(e) {
	console.log('exception errr ' + e);
      }
      console.log("#### SESSION UPDATED", this.session);
      this.attachMedia();
    },
    media: function(newVal, oldVal) {
      this.attachMedia();
      console.log('media: ', [[newVal]])
    },
    localVideo() {
      this.attachMedia();
    },
  },
};
</script>

<style scoped>
div[class*="col-"] {
  background: #fff;
  text-align: center;
  color: #000;
  border: 0px solid #ddd;
  padding: 5px;
}
.vidDiv {
  margin-top:1px;
}
.row {
  margin-bottom: 0px;
}
::v-deep .v-snack__wrapper {
  min-width: 150px;
}
.PULSE {
    /* Chrome, Safari, Opera */
  -webkit-animation: PULSE 1s infinite; 

  /* Internet Explorer */
  -ms-animation: PULSE 1s infinite;

  /* Standard Syntax */
  animation: PULSE 1.25s infinite; 
}

/* Chrome, Safari, Opera */
@-webkit-keyframes PULSE{
    0%{color:rgba(0,255,0);}	
  110%{color: black;}
}

/* Internet Explorer */
@-ms-keyframes PULSE{
  0%{color:rgba(0,255,0);}	
  110%{color: black;}
}

/* Standard Syntax */
@keyframes PULSE{
  0%{color:rgba(0,255,0);}	
  110%{color: black;}
}

.zerosize {
  width: 0px !important;
  height: 0px !important;
}
</style>
